"use strict";

var MggpVendor = require('mggp-player').Vendor;
var AddonError = require('mggp-player').AddonError;

function MggpVendorGroupedPrograms(pPlayer, pConfig) {
  MggpVendor.apply(this, arguments);

  var self = this;
  var _src = null;
  var _videoInfo = null;
  var _videoInfoCopy = null;
  var _vendorOptions = null;
  var _timeline = [];
  var _currentVendor = null;
  var _currentProgram = null;

  var _currentItem = null;
  var _clonePlayer = null;

  var _duration = 0;
  var _beforeDuration = 0;
  var _afterDuration = 0;
  var _getStreamFunction = null;
  var _needShowPostroll = false;
  var _lockSeek = false;

  pPlayer.registerProperty('playlist:info', null, false);
  pPlayer.registerProperty('playlist:item', null, false);

  this.dispose = function () {
    tooggleEvents(false);
    self.player.off("ad:external:adComplete", onAdComplete);

    _src = null;
    _videoInfo = null;
    _videoInfoCopy = null;
    _vendorOptions = null;
    _timeline = [];
    _currentVendor = null;
    _currentProgram = null;
    _currentItem = null;
    _clonePlayer = null;

    _needShowPostroll = false;
    _lockSeek = false;

    _duration = 0;
    _beforeDuration = 0;
    _afterDuration = 0;

    self.player = null;
    self.namespase = null;
    self.config = null;

    self.set("playlist:info", null);
    self.set("playlist:item", null);
  };

  this.load = function (pSrc, pVideoInfo, pOptions) {

    //Todo: Какая дичь, не удивлюсь если у нас сломаются смарт тв
    if (_currentVendor && _videoInfo && pVideoInfo.video_id === _videoInfo.video_id) {
      var time = Math.round(pOptions.startSeconds || 0);
      var target = findCurrentVideoFromTime(time);
      _currentProgram = findCurrentVideoFromTime(time);
      if (_currentVendor && _currentProgram && target.item && target.item.id === _currentProgram.item.id) {
        if (self.player.get('position') > 0) {
          pOptions.startSeconds = time - target.item.start;
          if(pOptions.startSeconds < 0) pOptions.startSeconds = 0;
        }
      }
      _currentVendor.load(pSrc, pVideoInfo, pOptions);

      return;
    }
    _needShowPostroll = false;
    _videoInfo = pVideoInfo;
    _src = pSrc || pVideoInfo.src;
    createTimeLine(pOptions);

    _currentProgram = findCurrentVideoFromTime(pOptions.startSeconds);
    if (!_currentProgram) {
      // TODO: поидее это еррор, хотя может и complete
    }

    // Убиваем grouped_programs, что-бы найти реального вендора
    delete pOptions.groupedPrograms;
    // Поскольку videoInfo и options могут мутировать в разных частях плеера...
    _videoInfoCopy = copy(_videoInfo);
    _vendorOptions = copy(pOptions);

    _getStreamFunction = pOptions.getStream;

    _vendorOptions.startSeconds = _currentProgram ? _currentProgram.startSeconds : 0;
    initItem(_currentProgram, _vendorOptions);
  };

  var initItem = function (pItem, pOptions, pNeedResetStartTime) {
    if(pItem.item.id === _videoInfoCopy.video_id) {//MHP-1284
      return createVendor(pItem.item, pOptions, _videoInfoCopy); //MHP-1390
    }

    if (typeof _getStreamFunction !== 'function') return;

    _getStreamFunction(pItem.item.id, function (pData) {
      pItem.item.src = _videoInfo.src = pData.src;
      createVendor(pItem.item, pOptions, pData);
      if(pNeedResetStartTime) pOptions.startSeconds = 0;
    })
  };

  var createVendor = function (pItem, pOptions, pNewInfo) {
    var ext = self.player.utils.getExtension(pItem.src);
    var timeout = 0;
    var stoppingPromise = undefined;

    // Необходимо сбрасывать дрм флаг в зависимости от перебивки
    var isDrm = Boolean(pNewInfo.drm_type && pNewInfo.drm_type.length);
    self.player.config.drm = isDrm;
    _videoInfo.drm_type = pNewInfo.drm_type;
    _videoInfo.is_wvdrm = pNewInfo.is_wvdrm;
    _videoInfo.license_server = pNewInfo.license_server;
    _videoInfo.license_certificate = pNewInfo.license_certificate;
    _videoInfo.wvls = pNewInfo.wvls;

    // Важно не трогать оригинал иначе мы удалим default-ы
    var options = copy(pOptions);
    options.isDrm = isDrm;

    if (_currentVendor) {
        stoppingPromise = _currentVendor.stop();
        _currentVendor = null;
        timeout = 300;
    }
    if (!_currentVendor) {
      var vendorInstance = self.player.getVendor(ext, options);
      if (vendorInstance) _currentVendor = new vendorInstance(getFakePlayer(), self.config);
    }

    var audio =  pItem.audioTrackList || pNewInfo.audio_tracks || [];

    self.player.set('src', pItem.src);
    self.player.set('qualityList', pItem.qualityList || []);
    self.player.set('audioTrackList', audio); //MHP-1698
    //self.player.set('subtitlesList', pItem.subtitlesList || []);
    //_videoInfo.content_type = pNewInfo.content_type;
    self.set('vendorOptions', options);

    if(audio.length < 2) delete options.defaultAudioTrack;
    if(!pItem.root) delete options.defaultSubtitles;

    if (_currentVendor) {
      if (stoppingPromise instanceof Promise) {
        stoppingPromise.finally(performLoad)
      } else {
        setTimeout(performLoad, timeout);
      }
      _currentItem = pItem;
      tooggleEvents(true);
    }
    function performLoad() {
      if(!_currentVendor) return;
      _currentVendor.load(pItem.src, _videoInfo, options);
      self.set('playlist:item', pItem);
    }
  };

  var getFakePlayer = function () {
    return _clonePlayer = {
      parentContainer: self.player.parentContainer,
      config: self.player.config,
      getPlayableElement: self.player.getPlayableElement,
      on: self.player.on,
      off: self.player.off,
      utils: self.player.utils,
      emit: function (pType, pData) {
        if(!self.player) return;
        switch (pType) {
          case 'player:mediaBeforeComplete':
            //nope
            break;
          case 'player:stateChange':
            if (pData !== 0) self.player.emit(pType, pData);
            break;
          default:
            self.player.emit(pType, pData)
        }

      },
      set: function (pName, pData) {
        if(!self.player) return;
        switch (pName) {
          case 'state':
            if (pData === 0) {
              onMediaBeforeComplete();
            } else if(pData === 4) { //MHP-1697
              break;
            } else {
              self.player.set(pName, pData);
            }
            break;

          case 'position': {
            _lockSeek = false;

            var position = 0;
            if (pData > 0) {
              position = pData > _currentItem.end ? _currentItem.end : pData + _currentItem.start;
            }
            self.player.set(pName, position);

            //MHP-1858: Форсировано завершать воспроизведение объекта по метке титров на М-канале
            if(self.player.get("state") === 1 && needForceStop(position)) {
                onMediaBeforeComplete();
            }
            break;
          }
          case 'duration': {
            self.player.set(pName, _timeline[_timeline.length - 1].end);
            break;
          }
          default:
            self.player.set(pName, pData);
        }

      },
      get: function (pName) {
        if(!self.player) return;
        switch (pName) {
          default:
            return self.player.get(pName);
        }
      }
    }
  };

  this.setQuality = function (pBitrate) {
    if (_currentVendor) _currentVendor.setQuality(pBitrate);
  };

  this.setAudioTrack = function (pIndex) {
    if (_currentVendor) {
      _currentVendor.setAudioTrack(pIndex);
      _vendorOptions.defaultAudioTrack = pIndex;
      _vendorOptions.startSeconds = self.player.get('position');
    }
  };

  this.setSubtitles = function (pLang) {
    if (_currentVendor) _currentVendor.setSubtitles(pLang);
  };

  this.play = function () {
    if (_currentVendor) _currentVendor.play();
  };

  this.pause = function () {
    if (_currentVendor) _currentVendor.pause();
  };

  this.stop = function () {
    // return promise (if exists) to player
    var promise;
    if (_currentVendor) {
      promise = _currentVendor.stop();
    }

    self.dispose();
    return promise;

  };

  this.togglePlayPause = function () {
    if (_currentVendor) _currentVendor.togglePlayPause();
  };

  this.seekTo = function (seconds) {
    if(_needShowPostroll || _lockSeek) return ;
    let target = findCurrentVideoFromTime(seconds);

    if(target) {
      if(target.item === _currentItem) {
        if(needForceStop(seconds + target.item.start)) return onMediaBeforeComplete();
        if (_currentVendor) {
          _lockSeek = true;
          _currentVendor.seekTo(seconds - target.item.start);
        }
      } else {
        _vendorOptions.startSeconds = seconds - target.item.start;
        initItem(target, _vendorOptions);
      }

      setState(4); //MHP-1697: Test 3 (fb) п3
      return;
    }

    if (_currentVendor) {
      _lockSeek = true;
      _currentVendor.seekTo(seconds);
    }
  };

  this.setVolume = function (pVolume) {
    if (_currentVendor) _currentVendor.setVolume(pVolume);
  };

  this.mute = function () {
    if (_currentVendor) _currentVendor.mute();
  };

  this.unMute = function () {
    if (_currentVendor) _currentVendor.unMute();
  };

  this.getPlayableElement = function () {
    return _currentVendor ? _currentVendor.getPlayableElement() : null;
  };

  var setState = function (pNewState) {
    self.set('state', pNewState);
    self.emit('stateChange', pNewState);
  };

  var needForceStop = function (position) {
    if(!self.config.creditsForceStopEnabled) return false;
    if(_currentItem.creditsStart && _currentItem.creditsStart > 0) {
      if (position > _currentItem.creditsStart + _currentItem.start) return true;
    }
    return false;
  }

  var onMediaBeforeComplete = function (pEvent) {
    for (var index = 0; index < _timeline.length; index++) {
      if (_timeline[index].start === _currentItem.start) break;
    }
    if (index < _timeline.length - 1) {
      _vendorOptions.startSeconds = 0;
      var options = copy(_vendorOptions);
      options.startSeconds = 0;
      initItem({item: _timeline[index + 1]}, options)
    } else {
      self.emit('mediaBeforeComplete');
      if(_currentVendor) {
        _currentVendor.stop();
        self.player.set("position", self.player.get("duration"));
      }

      _needShowPostroll = needShowPostroll();

      if(!_needShowPostroll) {
        setState(0);
      }
    }
  };

  var needShowPostroll = function() {
    if(self.player.get("postroll")) {
      self.player.on("ad:external:adComplete", onAdComplete);
      self.player.set('ad:skipAd', false);
      self.player.emit('ad:playerEnded');
      return true;
    }

    return false;
  }

  var onAdComplete = function() {
    setState(0);
  }

  var onTimeUpdate = function() {
    if(_needShowPostroll) {
      self.player.set('ad:skipAd', false);
      self.player.emit('ad:playerEnded');
    }
  }

  var tooggleEvents = function (pOn) {
    if (pOn) {
      self.player.on("player:timeUpdate", onTimeUpdate);
          } else {
      self.player.off("player:timeUpdate", onTimeUpdate);
          }
  };

  var findCurrentVideoFromTime = function (pTime) {
    var result = null;

    // Для начала пробуем найти точное совпадение
    _timeline.forEach(function (item) {
      if (pTime >= item.start && item.end >= pTime && !item.disabled) {
        result = {
          item: item,
          startSeconds: pTime - item.start
        };
      }
    });

    //Усли точного не получилось (часть disable например) нужно найти подходящий
    if (!result) {
      for (var i = 0; i < _timeline.length; i++) {
        var item = _timeline[i];
        // пробуем слева на право максимально близкий, первый не disabled
        if (!item.disabled && pTime < item.start) {
          result = {
            item: item,
            startSeconds: 0 //
          };
          break;
        }
      }
    }

    if (!result && _timeline.length === 1) {
      result = {
        item: _timeline[0],
        startSeconds: _timeline[0].end - 1,
      }
    }

    return result;
  };

  var createTimeLine = function (pOptions) {
    var groupedPrograms = pOptions.groupedPrograms;
    var programStartTimestamp = pOptions['startTimestamp'];
    var programEndTimestamp = pOptions['endTimestamp'];

    if (!groupedPrograms) return;

    var before = getItemsToTimeline(groupedPrograms['before'] || [], programStartTimestamp, programEndTimestamp, pOptions['disableBefore']);
    var after = getItemsToTimeline(groupedPrograms['after'] || [], programStartTimestamp, programEndTimestamp, pOptions['disableAfter']);
    var creditsStart = _videoInfo['content_type'] === 'm_ch_vod' ?  _videoInfo['credits_start'] || 0 : 0;

    _duration = programEndTimestamp - programStartTimestamp;
    _beforeDuration = before.length ? before[before.length - 1].end - before[0].start : 0;
    _afterDuration = after.length ? after[after.length - 1].end - after[0].start : 0;

    var mainContent = {
      start: _beforeDuration,
      end: _duration - _afterDuration,
      creditsStart: creditsStart,
      disabled: false,
      root: true,
      id: _videoInfo['video_id'],
      src: _videoInfo['src'],
      qualityList: copy(self.player.get('qualityList')),
      audioTrackList: copy(self.player.get('audioTrackList')),
      subtitlesList: copy(self.player.get('subtitlesList')),
    };

    _timeline.length = 0;

    before.forEach(function (item) {
      _timeline.push(item)
    });

    _timeline.push(mainContent);

    after.forEach(function (item) {
      _timeline.push(item)
    });

    self.set("playlist:info", {
      startOffset: _beforeDuration,
      endOffset: _afterDuration,
      duration: _duration,
      items: _timeline
    });
  };

  var getItemsToTimeline = function (pItems, pProgramStart, pProgramEnd, pDisabled) {
    var result = [];
    pItems.forEach(function (item) {
      result.push({
        start: item['start_timestamp'] - pProgramStart,
        end: pProgramEnd - pProgramStart - (pProgramEnd - item['end_timestamp']),
        disabled: pDisabled,
        src: null,
        root: false,
        id: item['object_id']
      })
    });

    return result;
  };

  var copy = function(pItem) {
    var result = null;
    try {
      result = JSON.parse(JSON.stringify(pItem));
    } catch (e) {}

    return result;
  };

  self.log('MggpVendorGroupedPrograms:Created!');
}

MggpVendorGroupedPrograms.prototype = Object.create(MggpVendor.prototype);
MggpVendorGroupedPrograms.prototype.constructor = MggpVendorGroupedPrograms;
MggpVendorGroupedPrograms.mimeTypes = ["mp4", "webm", "m3u8", "wvm", "mpd", "ism/Manifest", "xml"];
MggpVendorGroupedPrograms.priority = -1; // Поскольку большая часть вендоров на smart имеют приоритет 0 :(

MggpVendorGroupedPrograms.canPlayGroupedPrograms = function (pType, pConfig, pOptions) {
  return true;
};

MggpVendorGroupedPrograms.canPlay = function (pType, pConfig, pOptions) {
  return pOptions && pOptions['groupedPrograms'];
};

module.exports = MggpVendorGroupedPrograms;
